// extracted by mini-css-extract-plugin
module.exports = {"container":"nav_item_group-module__container--2tvsi"};